import type { LowerHex } from '../../../../types'

type CreateDirectionParameters = {
  readonly from: LowerHex | undefined
  readonly to: LowerHex | undefined
  readonly relatedAddresses: Set<LowerHex>
}

export const createDirection = ({
  from,
  to,
  relatedAddresses,
}: CreateDirectionParameters): 'in' | 'out' | 'none' => {
  if (
    from !== undefined &&
    relatedAddresses.has(from) &&
    (to === undefined || !relatedAddresses.has(to))
  ) {
    return 'out'
  }
  if (
    to !== undefined &&
    relatedAddresses.has(to) &&
    (from === undefined || !relatedAddresses.has(from))
  ) {
    return 'in'
  }
  return 'none'
}
